import { render, staticRenderFns } from "./ModalShell.vue?vue&type=template&id=5879560a&scoped=true&"
import script from "./ModalShell.vue?vue&type=script&lang=js&"
export * from "./ModalShell.vue?vue&type=script&lang=js&"
import style0 from "./ModalShell.vue?vue&type=style&index=0&id=5879560a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879560a",
  null
  
)

export default component.exports